enum menuConstants {
  BOOKING_FOR_MENU = 'BOOKING_FOR_MENU',
  LOCATION_MENU = 'LOCATION_MENU',
  GUESTS_MENU = 'GUESTS_MENU',
  DATES_MENU = 'DATES_MENU'
}

enum bookingConstants {
  BEDROOM_PROMOTION_MEMBER = 'SHMEM',
  BEDROOM_PROMOTION_FRIENDS = 'SHPUB',
  MYSELF_VALUE = 'myself',
  FRIENDS_AND_FAMILY_VALUE = 'friendsAndFamily',
  MEMBERS_ONLY_HOUSE_VALUE = 'closed',
  VETTED_HOUSE_VALUE = 'vetted',
}
export interface SearchFilters {
  location: {
    hotel: {
      id: string
    }
  },
  dates: {
    fromDate: string
    toDate: string
    label: string
  }
  guests: {
    adults: number
    children: number
  }
  bookingFor: {
    code: string
    value: string,
    label: string
  }
}

interface BookingForOption {
  label: string,
  code: string,
  enabled: boolean
}

enum calendarTypes {
  mobile = 'infinite',
  tablet = 'single',
  desktop = 'dual'
}

function bookingForMenu(isFriendsAndFamilyBookingAllowed: boolean | null): Array<BookingForOption> {
  const bookingForOptions = [
    {
      label: 'STAY_BROWSE_ROOMS_BOOKING_MYSELF_LABEL',
      value: bookingConstants.MYSELF_VALUE,
      code: bookingConstants.BEDROOM_PROMOTION_MEMBER,
      enabled: true
    },
    {
      label: 'STAY_BROWSE_ROOMS_BOOKING_FRIENDS_FAMILY_LABEL',
      value: bookingConstants.FRIENDS_AND_FAMILY_VALUE,
      code: bookingConstants.BEDROOM_PROMOTION_MEMBER, // Same code for both options
      enabled: Boolean(isFriendsAndFamilyBookingAllowed)
    }
  ]

  return bookingForOptions
}

export {
  menuConstants,
  calendarTypes,
  bookingConstants,
  bookingForMenu
}